import React from 'react';

export const Border = () => (
    <>
        <rect x="2" y="2" width="20" height="20" rx="1" fill="white" stroke="black" strokeLinejoin="round"/>
        <rect x="5" y="5" width="14" height="14" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="4 3"/>
    </>
);